import '../list.css'
import {sideBarConst} from "./const";
import {Urls} from "component/const/Urls";
import {useLocation, useNavigate} from "react-router-dom";
import {getRole, logout} from "component/const/ForAuth";

export const Sidebar = () => {
    const { pathname } = useLocation();

    const navigate = useNavigate();

    const logOut = (e) => {
        e.preventDefault();
        logout();
        navigate('/');
    }

    return (
        <div style={{margin:37, width: "fitContent", height: "fitContent",}} className="column sideBar">
            <img src="/images/profile.svg" alt="/images/profile.svg"
                style={{width: 128, height: 128, borderRadius: "50%"}}/>
            <h1 style={{textAlign:'center',fontSize : "2rem"}} className={`font-extrabold my-3`}>홍길동</h1>
            <div className='listHolderMyPage'>
                {sideBarConst.map(items => getRole() !== '사용자' ? items : items.filter(it => it.for === "사용자")
                    ).map((items, index) => (items.map((item, i) =>
                <div key={Urls.concat([index,item,i])}
                    className={i===0? 'titleMyPage':Urls.myPage+item.link===pathname? 'selectedMyPage': 'listItemMyPage'}
                     onClick={()=>i!==0 && navigate(Urls.myPage+item.link)}
                >{item.holder}</div>
                )))}
                <div className={'listItemMyPage'} onClick={logOut}>로그아웃</div>
            </div>
        </div>
    )}